import Vue from 'vue'
import { isNull } from '@/utils'
import getTranslation from '@/i18n/getTranslation'
Vue.filter('limiteStr', (str, count) => {
  if (isNull(str)) {
    return '-'
  } else if (str.length > count) {
    return str.slice(0, count) + '...'
  } else {
    return str
  }
})

Vue.filter('filterParams', val => {
  if (isNull(val)) {
    return '--'
  }
  return val
})
// 日期filter用于日期选择
Vue.filter('dateFilter', (val, index) => {
  if (val < 12) {
    return index === +val ? getTranslation(val + '个月') : getTranslation(val)
  } else {
    return getTranslation(val / 12 + '年')
  }
})
